import { useRef, useState } from "react";
import {
  Button,
  CircularProgress,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import DescriptionIcon from "@mui/icons-material/Description";
import { toast } from "sonner";
import { useDownloadSecureVolumePdfMutation } from "../../../../../store/services/secureVolumeService";

interface ForwardButtonProps {
  customerId: number;
  workId: number;
  /** Hämta volymerna från det som laddats upp till Zynergy i stället för ärendets sparade volymer */
  fromZynergy?: boolean;
}

/**
 * Skapar avtals-PDF för ärendet. Målåret bestäms av ärendet (TargetYear) på
 * backend – det går inte längre att välja år här.
 */
export const ForwardButton = ({ customerId, workId, fromZynergy }: ForwardButtonProps) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [downloadPdf, { isLoading }] = useDownloadSecureVolumePdfMutation();

  const handleSelect = async (variant: "full" | "appendix" | "appendix-nochange") => {
    setMenuOpen(false);

    try {
      await downloadPdf({
        customerId,
        workId,
        type: variant,
        ...(fromZynergy ? { fromZynergy: true } : {}),
      }).unwrap();
    } catch {
      toast.error("Det gick inte att generera PDF. Försök igen.");
    }
  };

  return (
    <>
      <Button
        ref={anchorRef}
        variant="outlined"
        size="small"
        startIcon={isLoading ? <CircularProgress size={16} /> : <SendIcon />}
        onClick={() => setMenuOpen(true)}
        disabled={isLoading}
      >
        {fromZynergy ? "Skapa om från Zynergy" : "Skapa avtal"}
      </Button>
      <Menu
        anchorEl={anchorRef.current}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
      >
        <MenuItem onClick={() => handleSelect("appendix")}>
          <ListItemIcon>
            <MarkEmailReadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Anläggningslista <b>med</b> signering</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleSelect("appendix-nochange")}>
          <ListItemIcon>
            <DescriptionIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Anläggningslista, <b>ingen</b> signering</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
